import API from "..";

export interface LoginParameters {
  email: string;
  password: string;
}

export const login = async (params: LoginParameters) => API.post<string>('/auth/login', params);